import {
  Flex,
  Heading,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageHeaderIcons from "./PageHeaderIcons";
import { useTenant } from "modules/tenant/providers/tenant-provider";

export default function PageHeader({
  title,
  hideUser,
  breadcrumbs = [],
}: {
  title: string;
  hideUser?: boolean;
  breadcrumbs?: any[];
}) {
  const { user } = useTenant();

  return (
    <Flex justifyContent="space-between" alignItems="center" mb={4}>
      <VStack alignItems="left">
        <Heading
          fontWeight="600"
          fontSize="30px"
          lineHeight="150%"
          letterSpacing="-1.1%"
          textTransform="capitalize"
          mb="0px"
        >
          {title}
        </Heading>

        {breadcrumbs.length > 0 && (
          <Breadcrumb
            mt="0px"
            spacing="8px"
            separator={<FontAwesomeIcon icon={["far", "chevron-right"]} color="black" size="xs" />}
          >
            {breadcrumbs.map((crumb, crumbIndex) => (
              <BreadcrumbItem
                mt="0px"
                fontSize="16px"
                color="black"
                fontWeight="500"
                key={crumb.title}
                isCurrentPage={crumbIndex === breadcrumbs.length - 1}
              >
                {crumb.to ? (
                  <BreadcrumbLink href={crumb.to}>{crumb.title}</BreadcrumbLink>
                ) : (
                  <Text>{crumb.title}</Text>
                )}
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
        )}
      </VStack>
      {!hideUser && <PageHeaderIcons user={user} />}
    </Flex>
  );
}
